import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ViewBookings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabStatus = location.state?.tabStatus || "Pending";

  return (
    <>
      <div className="main_title">
        <h1>Booking Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-bookings")}>
            Booking Management
          </button>{" "}
          - Booking Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="w_33">
            <h6>Booking ID</h6>
            <p>#BK2025001</p>
          </div>

          <div className="w_33">
            <h6>Service Details</h6>
            <p>Hair Color</p>
          </div>
          <div className="w_33">
            <h6>Selected Date & Time Slot</h6>
            <p>25 Aug 2025, 10:00 AM - 12:00 PM</p>
          </div>

          <div className="w_33">
            <h6>Notes</h6>
            <p>Bring extra tools.</p>
          </div>
          <div className="w_33">
            <h6>Customer Address</h6>
            <p>Dubai Marina, Tower A, Apartment 101</p>
          </div>
          <div className="w_33">
            <h6>Service Provider Address</h6>
            <p>Al Quoz Industrial Area, Dubai</p>
          </div>
          <div className="w_33">
            <h6>Selected Services</h6>
            <p>
              Haircut <strong>($6.00)</strong> , Hair Spa{" "}
              <strong>($14.50)</strong>
            </p>
          </div>
          <div className="w_33">
            <h6>Total Price</h6>
            <p>AED 300</p>
          </div>
          <div className="w_33">
            <h6>Service Provider Details</h6>
            <div className="user_block click_action">
              <figure>
                <img src="/static/images/user_placeholder.png" alt="" />
              </figure>
              <p>
                <b>Blossom Beauty Studio</b>
                <span>Haircut & Hair Color</span>
              </p>
            </div>
          </div>
          <div className="w_33">
            <h6>Customer Details</h6>
            <div className="user_block click_action">
              <figure>
                <img src="/static/images/user_placeholder.png" alt="" />
              </figure>
              <p>
                <b>Madelyn Dias</b>
                <span>madelyndias@gmail.com</span>
                <span>+91 9876543210</span>
              </p>
            </div>
          </div>

          {/* Show Rating & Review ONLY if Completed */}
          {tabStatus === "Completed" && (
            <>
              <div className="w_33">
                <h6>Rating</h6>
                <p>4 Star</p>
              </div>
              <div className="w_33">
                <h6>Review</h6>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam,
                  rerum.
                </p>
              </div>
            </>
          )}

          {/* Show Cancel Info ONLY if Cancelled */}
          {tabStatus === "Cancelled" && (
            <>
              <div className="w_33">
                <h6>Cancelled By</h6>
                <p>Admin</p>
              </div>
              <div className="w_33">
                <h6>Cancelled On</h6>
                <p>20 Aug 2025, 05:45 PM</p>
              </div>
              <div className="w_33">
                <h6>Cancellation Reason</h6>
                <p>Customer requested to reschedule</p>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewBookings;
